export function getYearOptions(): string[] {
  const startYear = 2022;
  const currentYear = new Date().getFullYear();
  const years: string[] = [];
  for (let year = startYear; year <= currentYear; year++) {
    years.push(year.toString());
  }
  return years;
}
